export { default } from "./SearchAd";
